import { FormattedMessage } from 'react-intl'
import { Button, DialogConfirmation } from '@carto/meridian-ds/components'

interface NewExportSqlAlertProps {
  onConfirm: () => void
  onCancel: () => void
  opened: boolean
}

function NewExportSqlAlert({ onConfirm, onCancel, opened }: NewExportSqlAlertProps) {
  return (
    <DialogConfirmation
      opened={opened}
      severity="warning"
      onClickAway={onCancel}
      actions={
        <>
          <Button onClick={onCancel}>
            <FormattedMessage id="common.button.cancel" />
          </Button>
          <Button variant="contained" onClick={onConfirm}>
            <FormattedMessage id="common.button.clear" />
          </Button>
        </>
      }
    >
      <FormattedMessage id="data-explorer.subscription.exportDialog.sqlEditorWarning" />
    </DialogConfirmation>
  )
}

export default NewExportSqlAlert
